<template lang="pug">
  .selected-color-category
    .status
      figure.status-label: img(src='@/assets/image/unit_title.svg' alt='UNIT')
      p.status-name {{ getColorName('unit').name }}
    .status
      figure.status-label: img(src='@/assets/image/seat_title.svg' alt='SEAT')
      p.status-name
        span.category-name(
          v-if='getColorName("seat").category'
          :class='{ break: getColorName("seat").category === "Fukka-Fukka シート 2トーンカラー" }'
        ) {{ getColorName('seat').category }}
        span {{ getColorName('seat').name }}
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'SelectStatus',
  computed: {
    ...mapGetters(['getColorName']),
  },
};
</script>

<style lang="scss" scoped>
.selected-color-category {
  position: absolute;
  top: vw(132);
  left: vw(34);
  z-index: 99;
  margin-right: vw(44);
}

.status {
  display: flex;
  margin-top: vw(12);

  &:first-of-type {
    margin-top: 0;
  }

  %common {
    height: vw(28);
    line-height: vw(28);
  }

  &-label {
    display: flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    width: vw(70);
    margin-right: vw(18);
    border: 1px solid #000;

    img {
      @extend %common;

      object-fit: scale-down;
    }
  }

  &-name {
    @extend %common;

    padding-left: 0;
    font-size: vw(20);
  }
}

.category-name {
  margin-right: vw(10);

  &.break {
    display: block;
  }
}
</style>
